import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Chip from '@mui/material/Chip';
import { useAppXrResource } from './useAppXrResource';

const KIND_CATEGORY: Record<string, string> = {
  Deployment: 'Workload',
  Service: 'Workload',
  ServiceAccount: 'Workload',
  Namespace: 'Workload',
  HTTPRoute: 'Networking',
  GCPBackendPolicy: 'Networking',
  HealthCheckPolicy: 'Networking',
  ImagePolicy: 'Image Automation',
  ImageRepository: 'Image Automation',
  Alert: 'Observability',
  XSandbox: 'Composite',
  ProviderConfig: 'Config',
};

const CATEGORY_COLOR: Record<
  string,
  'primary' | 'secondary' | 'info' | 'warning'
> = {
  Workload: 'primary',
  Networking: 'info',
  'Image Automation': 'secondary',
  Observability: 'warning',
  Composite: 'secondary',
};

export const AppComposedResourcesCard = () => {
  const { resource, loading } = useAppXrResource();
  const refs = resource?.spec?.crossplane?.resourceRefs;

  if (loading || !refs || refs.length === 0) return null;

  return (
    <Card>
      <CardHeader
        title="Composed Resources"
        subheader={`${refs.length} managed resources`}
      />
      <CardContent sx={{ pt: 0, '&:last-child': { pb: 1.5 } }}>
        <Table size="small">
          <TableBody>
            {refs.map(ref => {
              const category = KIND_CATEGORY[ref.kind] ?? 'Other';
              return (
                <TableRow
                  key={`${ref.kind}-${ref.name}`}
                  sx={{ '&:last-child td': { border: 0 } }}
                >
                  <TableCell sx={{ py: 0.5, pl: 0, width: 100 }}>
                    <Chip
                      label={category}
                      size="small"
                      color={CATEGORY_COLOR[category] ?? 'default'}
                      variant="outlined"
                      sx={{
                        height: 20,
                        fontSize: '0.7rem',
                        '& .MuiChip-label': { px: 0.75 },
                      }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      py: 0.5,
                      fontSize: '0.8rem',
                      fontFamily: 'monospace',
                    }}
                  >
                    {ref.kind}
                  </TableCell>
                  <TableCell
                    sx={{
                      py: 0.5,
                      fontSize: '0.8rem',
                      fontFamily: 'monospace',
                    }}
                  >
                    {ref.name}
                  </TableCell>
                  <TableCell
                    sx={{
                      py: 0.5,
                      pr: 0,
                      fontSize: '0.8rem',
                      fontFamily: 'monospace',
                      color: 'text.secondary',
                    }}
                  >
                    {ref.namespace ?? '—'}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
